<template>
    <div class="user-tree">
        <UserTreeGroup
            v-for="group in groups"
            :key="group.key"
            :group="group"
            :collapsed="!isFiltered && collapsedKeys.has(group.key)"
            :is-filtered="isFiltered"
            :actor-id="actorId"
            :partner-names="partnerNames"
            :advertiser-names="advertiserNames"
            :busy-user-id="busyUserId"
            @toggle="toggle"
            @action="(action, user) => emit('action', action, user)"
        />
    </div>
</template>

<script setup>
import { reactive } from 'vue';
import UserTreeGroup from './UserTreeGroup.vue';

defineProps({
    groups: { type: Array, required: true },
    isFiltered: { type: Boolean, default: false },
    actorId: { type: Number, required: true },
    partnerNames: { type: Map, required: true },
    advertiserNames: { type: Map, required: true },
    busyUserId: { type: Number, default: null },
});

const emit = defineEmits(['action']);

/** При активном поиске/фильтре группы всегда раскрыты — иначе найденное не видно. */
const collapsedKeys = reactive(new Set());

const toggle = (key) => {
    if (collapsedKeys.has(key)) collapsedKeys.delete(key);
    else collapsedKeys.add(key);
};
</script>
